export const calculateDisplayEmail = (emailObject) => {
  const { email, workEmail, personalEmail } = emailObject ?? {};

  if (workEmail) return workEmail;
  if (personalEmail) return personalEmail;
  return email ?? '';
};
